import React, { Component, useState, createRef } from "react";
import "./index.scss";
import RequestOTP from "./RequestOTP/requestOTP";
import DexterLogo from "./icons/Dexter.svg";
import SubmitOTP from "./SubmitOTP/submitOTP";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

class Authentication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentScreen: "request",
      otpInfo: null,
    };
  }

  changeScreen = () => {
    this.setState((prevState) => ({
      currentScreen:
        prevState.currentScreen === "submit" ? "request" : "submit",
    }));
  };
  switchToSubmitOTP = (info) => {
    this.setState({ otpInfo: info, currentScreen: "submit" });
  };
  render() {
    const { authToken } = this.props;
    if (authToken && authToken.token) return <Redirect to="/" />;
    return (
      <div className="auth-container">
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
          size="invisible"
        />
        <img
          className="dexter-logo"
          src={DexterLogo}
          onClick={this.changeScreen}
        />

        {this.state.currentScreen === "request" ? (
          <RequestOTP switchToSubmitOTP={this.switchToSubmitOTP} />
        ) : (
          <SubmitOTP otpInfo={this.state.otpInfo} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    authToken: state.auth.authToken,
    logging_in: state.auth.logging_in,
    authStatusCode: state.auth.authStatusCode
      ? state.auth.authStatusCode
      : null,
    authResponseMessage: state.auth.authResponseMessage
      ? state.auth.authResponseMessage
      : null,
    authFreeze: state.auth.authFreeze,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Authentication);
